import React from 'react'
import { Button, ConfirmationModal } from '@components/common'
import './ManageContactGroupStyle.css'

type ConfirmCancelModalProps = {
  show: boolean
  onHide: () => void
  onCancel: () => void
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({
  show,
  onHide,
  onCancel,
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title="Discard changes"
      className="confirmation-modal--alert confirm-cancel-modal"
      headerClassName="confirmation-modal__header"
      size="md"
      backdrop="static"
      body={
        <div className="confirmation-modal__body">
          <p className="confirmation-modal__title">Discard changes?</p>
          <p className="confirmation-modal__message">
            Any unsaved changes will be lost. Are you sure you want to cancel?
          </p>
        </div>
      }
      footer={
        <div className="confirmation-modal__footer">
          <Button size="md" className="button-secondary" onClick={onHide}>
            Go back
          </Button>
          <Button
            size="md"
            className="button-destructive-primary"
            onClick={onCancel}
          >
            Cancel anyway
          </Button>
        </div>
      }
    />
  )
}

export default ConfirmCancelModal
